import usePreliminaryLifecarePlan from '../../hooks/usePreliminaryLifecarePlan';
import PreliminaryLifecarePlanLayout from './PreliminaryLifecarePlanLayout';

const PreliminaryLifecarePlan = () => {
    const studioState = usePreliminaryLifecarePlan();
    return <PreliminaryLifecarePlanLayout studioState={studioState} />;
};

export default PreliminaryLifecarePlan;
